import { render } from "./Subtitle.vue?vue&type=template&id=5a8122ed&scoped=true"
const script = {}

import "./Subtitle.vue?vue&type=style&index=0&id=5a8122ed&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8122ed"],['__file',"src/components/survey/Subtitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a8122ed"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a8122ed', __exports__)) {
    console.log('reload')
    api.reload('5a8122ed', __exports__)
  }
  
  module.hot.accept("./Subtitle.vue?vue&type=template&id=5a8122ed&scoped=true", () => {
    console.log('re-render')
    api.rerender('5a8122ed', render)
  })

}


export default __exports__